import { FC, useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";

import { Textbox } from "capitalrx-components-2.0/lib/forms";

import { ProviderPaymentRemittanceDataForm } from "./PaymentRemittanceGroupFields";

const valLength = 9;

export const formatValueRoutingNumber = (val: string) => {
  return (val ?? "").replace(/[^0-9,*]/g, "").slice(0, valLength);
};
export const formatValueRoutingNumberSecret = (val: string) => {
  const number = formatValueRoutingNumber(val);
  return number.replace(/./g, "*").slice(0, -4) + number.slice(-4);
};

const nameField = "routing_number";

export interface RoutingNumberFieldProps {
  readonly readOnly: boolean;
}

export const RoutingNumberField: FC<RoutingNumberFieldProps> = ({ readOnly }) => {
  if (readOnly) {
    return <RoutingNumberReadOnly />;
  }

  return <RoutingNumber />;
};

export const RoutingNumber = () => {
  const { setValue, watch } = useFormContext<ProviderPaymentRemittanceDataForm>();
  useEffect(() => {
    const { unsubscribe } = watch((value, { name }) => {
      const maskVal = formatValueRoutingNumber(value[nameField]);
      if (nameField === name && value[nameField] !== maskVal) {
        setValue(nameField, maskVal);
      }
    });
    return () => {
      unsubscribe();
    };
  }, [setValue, watch]);

  return (
    <Textbox.Field
      label="Routing Number"
      name={nameField}
      testId={nameField}
      instructions={`${valLength}-digits`}
      required
      minLength={valLength}
      maxLength={valLength}
    />
  );
};

export const RoutingNumberReadOnly = () => {
  const { control } = useFormContext<ProviderPaymentRemittanceDataForm>();
  const routingNumber = useWatch({
    control,
    name: nameField,
  });

  return (
    <Textbox
      key={`${nameField}_secret`}
      label="Routing Number"
      testId={`${nameField}_secret`}
      instructions={`${valLength}-digits`}
      value={formatValueRoutingNumberSecret(routingNumber)}
      readOnly
    />
  );
};
